export default "__VITE_ASSET__BnmcHB2A__"